import store from 'store'
import { EDUCATION_GROUP_ID, PRODUCT_LIST, PRODUCT_LIST_FREE } from 'common/constants/ProductConstants'

export const CONDITIONS = {
    CAN_USE_CUSTOM_PROJECT_STYLES: 'CAN_USE_CUSTOM_PROJECT_STYLES',
    CAN_USE_CUSTOM_PROJECT_TRANSLATIONS: 'CAN_USE_CUSTOM_PROJECT_TRANSLATIONS',
    CAN_USE_GAMIFICATION: 'CAN_USE_GAMIFICATION',
    CAN_USE_SDK_INTEGRATION: 'CAN_USE_SDK_INTEGRATION',
    CAN_USE_LEAD_FORM_IN_BLOCKS: 'CAN_USE_LEAD_FORM_IN_BLOCKS',
    CAN_USE_FULL_STATISTICS: 'CAN_USE_FULL_STATISTICS',
    CAN_USE_PREMIUM_BLOCKS: 'CAN_USE_PREMIUM_BLOCKS',
    CAN_INVITE_IN_TEAM: 'CAN_INVITE_IN_TEAM',
    CAN_USE_CUSTOM_PROJECT_ID: 'CAN_USE_CUSTOM_PROJECT_ID',
    CAN_USE_MAILCHIMP: 'CAN_USE_MAILCHIMP',
}
const isEnterpriseSubscription = productCode =>
    productCode === PRODUCT_LIST.Enterprise || productCode === PRODUCT_LIST.EnterpriseYear
const isConstraintUnlimited = constraint => constraint.featureProduct.productOptionValue === -1

const CONDITIONS_RULES = {
    [CONDITIONS.CAN_USE_CUSTOM_PROJECT_STYLES]: ({ productCode }) => isEnterpriseSubscription(productCode),
    [CONDITIONS.CAN_USE_CUSTOM_PROJECT_TRANSLATIONS]: ({ productCode }) => isEnterpriseSubscription(productCode),
    [CONDITIONS.CAN_USE_GAMIFICATION]: ({ featureList }) => featureList.includes('GAMIFICATION'),
    [CONDITIONS.CAN_USE_SDK_INTEGRATION]: ({ featureList }) => featureList.includes('SDK_INTEGRATION'),
    [CONDITIONS.CAN_USE_LEAD_FORM_IN_BLOCKS]: ({ featureList }) => featureList.includes('LEAD_COLLECTION_FORM'),
    [CONDITIONS.CAN_USE_FULL_STATISTICS]: ({ featureList }) => featureList.includes('FULL_STATISTICS'),
    [CONDITIONS.CAN_USE_PREMIUM_BLOCKS]: ({ featureList }) => featureList.includes('PREMIUM_BLOCKS'),
    [CONDITIONS.CAN_INVITE_IN_TEAM]: ({ constraints, memberList }) =>
        constraints.find(
            constraint =>
                constraint.featureProduct.featureType === 'TEAM' &&
                (isConstraintUnlimited(constraint) ||
                    constraint.featureProduct.productOptionValue > memberList.length - 1),
        ),
    [CONDITIONS.CAN_USE_CUSTOM_PROJECT_ID]: ({ featureList }) => featureList.includes('CUSTOM_PROJECT_URL'),
    [CONDITIONS.CAN_USE_MAILCHIMP]: ({ featureList }) => featureList.includes('INTEGRATIONS'),
}

export const hasPermission = (conditions = []) => {
    const { organizations } = store.getState()
    let result = true
    for (const condition of Array.isArray(conditions) ? conditions : [conditions]) {
        if (!CONDITIONS.hasOwnProperty(condition)) {
            result = false
            break
        }

        const isAllowed = CONDITIONS_RULES[condition]({
            productCode: organizations.selectedSubscription.product.productCode,
            featureList: organizations.selectedSubscription.product.featureProducts.map(el => el.featureType),
            constraints: organizations.selectedSubscription.constraints,
            memberList: organizations.memberList,
        })
        if (!isAllowed) {
            result = false
            break
        }
    }
    return result
}

export const isOwner = () => {
    const {
        organizations: { organizationList, selectedOrganizationId },
        user_details,
    } = store.getState()
    const selectedOrganization = organizationList.find(org => org.id === selectedOrganizationId)
    return selectedOrganization.ownerId === user_details.id
}

export const isEducation = () => {
    const { user_details } = store.getState()
    if (user_details) {
        return user_details.roleInProjectDto
            ? user_details.roleInProjectDto.userGroupInProjectDto.customId === EDUCATION_GROUP_ID
            : false
    }
    return false
}

export const isTrialSubscription = () => {
    const {
        organizations: { selectedSubscription },
    } = store.getState()

    return selectedSubscription && selectedSubscription.product.productCode === PRODUCT_LIST_FREE.Trial
}

export const isDeprecatedSubscription = () => {
    const {
        organizations: { selectedSubscription },
    } = store.getState()

    return selectedSubscription && selectedSubscription.product.productCode === PRODUCT_LIST_FREE.Free
}

export const isSubscriptionActivated = () => {
    const {
        organizations: { selectedSubscription },
    } = store.getState()

    return selectedSubscription && selectedSubscription.started !== null
}

export const isSubscriptionExpired = () => {
    const {
        organizations: { selectedSubscription },
    } = store.getState()

    return selectedSubscription && selectedSubscription.expirationDate <= new Date().getTime()
}

export const isFreeSubscription = () => {
    const {
        organizations: { selectedSubscription },
    } = store.getState()

    const codes = Object.values(PRODUCT_LIST_FREE)
    return selectedSubscription && codes.includes(selectedSubscription.product.productCode)
}
